import CustomizeOffers from './customize-offers/CustomizeOffers';
import OffersDisclaimer from './disclaimer/OffersDisclaimer';
import Offers from './offers/Offers';
import ApprovalBanner from './approval-banner/ApprovalBanner';
import offersV2 from './offers-v2';

export default {
    CustomizeOffers,
    OffersDisclaimer,
    ApprovalBanner,
    Offers,
    offersV2,
};